import posthog from "posthog-js";

import {
  getPostHogInitOptions,
  shouldInitializePostHog,
} from "@/lib/analytics/posthog-init";
import { getPostHogProjectToken } from "@/lib/analytics/env";

let initialized = false;

/** Single client init — call from instrumentation-client only. */
export function initPostHogClient(): void {
  if (initialized || !shouldInitializePostHog()) return;

  const apiKey = getPostHogProjectToken();
  const options = getPostHogInitOptions();
  if (!apiKey || !options) return;

  if (!posthog.__loaded) {
    posthog.init(apiKey, options);
  }
  initialized = true;
}
